import React from "react";
import { Icon , IconProps } from "@chakra-ui/react";

const DeleteIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 17" w="16px" h="17px" {...props}>
    <path
      d="M4 16C3.54167 16 3.14931 15.8368 2.82292 15.5104C2.49653 15.184 2.33333 14.7917 2.33333 14.3333V3.5H1.5V1.83333H5.66667V1H10.6667V1.83333H14.8333V3.5H14V14.3333C14 14.7917 13.8368 15.184 13.5104 15.5104C13.184 15.8368 12.7917 16 12.3333 16H4ZM12.3333 3.5H4V14.3333H12.3333V3.5ZM5.66667 12.6667H7.33333V5.16667H5.66667V12.6667ZM9 12.6667H10.6667V5.16667H9V12.6667Z"
      fill="#CD2929"
    />
  </Icon>
);

export default DeleteIcon;
